<template>
  <viewcard--c
    :title="
      $route.params.id > 0 ? 'Atualizar Convidado' : 'Cadastrar Convidado'
    "
    :btsave="$route.params.id > 0 ? btedit : btcreate"
    :btdelete="$route.params.id > 0 ? btdelete : null"
    :btback="{}"
    :busy="loading"
    @clicked-save="save"
    @clicked-delete="confirmDelete"
  >
    <b-form @submit.prevent>
      <b-row>
        <b-col md="6">
          <b-form-group label="Nome">
            <b-form-input
              v-model="record.name"
              placeholder="Nome do Convidado"
              autocomplete="off"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="E-mail">
            <div class="form-label-group">
              <b-form-input
                type="email"
                v-model="record.email"
                placeholder="Informe um e-mail"
                autocomplete="off"
              />
            </div>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Telefone">
            <div class="form-label-group">
              <b-form-input
                v-model="record.phone"
                placeholder="Telefone"
                v-mask="$utils.masked.phone"
              />
            </div>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </viewcard--c>
</template>
<script>
import _guestsService from "@/services/guests-service";
export default {
  data() {
    return {
      btedit: { permission: `permission.guest.edit` },
      btcreate: { permission: `permission.guest.create` },
      btdelete: { permission: `permission.guest.delete` },
      loading: false,
      states: [],
      stateSelected: { label: "estado....", value: "-3" },
      record: {
        id: 0,
        name: "",
        phone: "",
        email: "",
      },
    };
  },
  created() {
    this.states = this.$utils.getStates();
  },
  mounted() {
    this.getRecord();
  },
  methods: {
    getRecord() {
      if (this.$route.params.id > 0) {
        this.loading = true;
        _guestsService
          .find(this.$route.params.id)
          .then((res) => {
            this.record = res.content;
          })
          .catch((error) => this.$utils.toastError("Notificação", error))
          .finally(() => (this.loading = false));
      }
    },
    save() {
      this.record.uf = this.$utils.getValueSelected(this.stateSelected);

      const payload = { data: { ...this.record } };

      //promisse
      const _createOrUpdate =
        this.record.id <= 0
          ? _guestsService.create(payload)
          : _guestsService.update(payload);

      this.loading = true;
      _createOrUpdate
        .then(() => {
          this.$utils.toast("Notificação", "Convidado salvo com sucesso.");
          this.$router.go(-1);
        })
        .catch((error) => this.$utils.toastError("Notificação", error))
        .finally(() => (this.loading = false));
    },
    confirmDelete() {
      this.$swal({
        title: "Tem certeza?",
        text: "Isso não pode ser revertido!",
        icon: "error",
        showCancelButton: true,
        confirmButtonText: "Sim, quero excluir!",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn btn-info",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.excluir();
        }
      });
    },
    excluir() {
      this.loading = true;
      _GuestsService
        .delete(this.record.id)
        .then(() => {
          this.$utils.toast("Notificação", "Excluido com sucesso.");
          this.$router.go(-1);
        })
        .catch((error) => this.$utils.toastError("Notificação", error))
        .finally(() => (this.loading = false));
    },
  },
};
</script>